<template>
  <div>
    <label
      v-if="!hideLabel"
      class="control-label col-md-3 col-sm-3"
    >{{ label }}
      <a
        v-if="hasTooltip"
        v-tooltip.right="tooltipText"
      >
        &nbsp;&nbsp;<i class="fa fa-question-circle" />
      </a>
    </label>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BaseFormField',
  props: {
    label: {
      type: String,
      default: ''
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    hasTooltip: {
      type: Boolean,
      default: false
    },
    tooltipText: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss">
</style>